var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPie(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 43,
    fill: "#333852",
    fillOpacity: 0.1,
    rx: 18,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333852",
    strokeWidth: 2,
    d: "M13.571 3.347C6.498 3.996 1 9.94 1 17.143 1 24.773 7.143 30.953 14.778 31a13.872 13.872 0 0 0 12.657-7.997L14.751 19.74a1.566 1.566 0 0 1-1.18-1.519V3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#856DCB",
    strokeWidth: 2,
    d: "M17.286 1.021v15.293l12.945 3.32c.277-.765.479-1.695.61-2.716.108-.83.152-1.568.159-2.086v-.025c0-7.371-4.949-13.37-13.714-13.786zm13.539 18.765l.028.008a.743.743 0 0 0-.028-.008zm-.746.27a.669.669 0 0 0-.072.123l.06-.132z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPie);
export default __webpack_public_path__ + "static/media/icon-pie.12b48ecf31a435433e639a25287bfd94.svg";
export { ForwardRef as ReactComponent };